import { mdiFilter } from "@mdi/js";
import Category from "../classes/Category";
import { useAuthUserStore } from "../stores/authUser";

const PERSON_CATEGORIES_TAB_TEMPLATES = 108;
const PERSON_CATEGORIES_TAB_PARENTS = 177;

class PersonCategory extends Category {
  static model = "person_category";

  static tableHeaders = [
    { textKey: "form.label.name", value: "name" },
    { text: "", value: "tags", sortable: false },
  ];

  static createNewObject = {
    ...Category.createNewObject,
    object: { icon: "person" },
  };

  static submenuActions = [
    {
      icon: mdiFilter,
      titleKey: "person.persons",
      link: (object) => `/#/persons?category_id=${object.id}`,
      target: "_self",
    },
    ...Category.submenuActions,
  ];

  static tabs = [
    ...Category.tabs,
    {
      titleKey: "category.label.parents",
      permission: PERSON_CATEGORIES_TAB_PARENTS,
      component: "CategoryParentsTab",
      disabled: () => {
        const authUserStore = useAuthUserStore();
        return !["implementer", "admin"].includes(authUserStore.tier);
      },
    },
    {
      titleKey: "template.templates",
      permission: PERSON_CATEGORIES_TAB_TEMPLATES,
      component: "TemplatesAssignmentsTab",
      parameters: { entity_type: "Category" },
      disabled: () => {
        const authUserStore = useAuthUserStore();
        return !["implementer", "admin"].includes(authUserStore.tier);
      },
    },
  ];
}

export default PersonCategory;
